/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesVideoRolesPanelComponent(this: JS5Object, _: JS5Object, $location: JS5Object) {
    this.videoRole = {};
    this.$onInit = () => {
        setupTabs();
        setVideoRole(this.activeTab);
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
    };
    this.$onChanges = () => {
        setupTabs();
        setVideoRole(this.activeTab);
    };
    const setVideoRole = (videoRole: JS5Object) => {
        _.unset(this, 'videoRole');
        _.set(this, 'videoRole', videoRole);
        $location.search('videoRole', _.get(videoRole, 'role.id'));
    };
    this.onTabSelect = (videoRole: JS5Object) => {
        setVideoRole(videoRole);

    };

    const setupTabs = () => {
        _.set(this, 'editData.contentCategoryObject.videoRoles', _.chain(_.get(this, 'editData.contentCategoryObject.videoRoles'))
            .sortBy((videoRole: JS5Object) => {
                return _.lowerCase(videoRole.role.name);
            }).partition((videoRole: JS5Object) => {
                return videoRole.role.name === 'Main Video';
            }).flatten()
            .value());

        if (!_.isNil($location.search().videoRole)) {
            this.activeTab = this.activeTab ? this.activeTab : _.find(_.get(this, 'editData.contentCategoryObject.videoRoles'), (videoRole: JS5Object) => {
                return videoRole.role.id === $location.search().videoRole;
            });
        } else {
            this.activeTab = this.activeTab ? this.activeTab : _.find(_.get(this, 'editData.contentCategoryObject.videoRoles'), (videoRole: JS5Object) => {
                return videoRole.role.name === 'Main Video';
            });
        }
    };
}


angular.module('prism-ui.content').component('contentCategoriesVideoRolesPanel', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/videoRolesPanel/content-categories-video-roles-panel-template.html',
    controller: ContentCategoriesVideoRolesPanelComponent,
    bindings: {
        editData: '<'
    }
});
